// Sort an array of users by their `lastActivity` timestamp.
// Users without a `lastActivity` value are always placed at the end.
// When `descending` is true (default), the most recently seen user comes first.
export const sortByLastSeen = (users, descending = true) => {
  if (!users) return [];
  return [...users].sort((a, b) => {
    if (!a?.lastActivity && !b?.lastActivity) return 0;
    if (!a?.lastActivity) return 1;
    if (!b?.lastActivity) return -1;
    const aTime = Number(a.lastActivity);
    const bTime = Number(b.lastActivity);
    return descending ? bTime - aTime : aTime - bTime;
  });
};
